// polyfills
import 'custom-event-polyfill';
import 'unfetch/polyfill';
import 'es6-promise/auto';

//import files to bundle with rollup
import { load } from '@shopify/theme-sections';
import PubSub from 'pubsub-js';
import './lib/global';
//import './sections/cart';
import './sections/header';

if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

window.PubSub = PubSub;

load('*')
